import { render, staticRenderFns } from "./previewImg.vue?vue&type=template&id=7635dba0&scoped=true&"
import script from "./previewImg.vue?vue&type=script&lang=js&"
export * from "./previewImg.vue?vue&type=script&lang=js&"
import style0 from "./previewImg.vue?vue&type=style&index=0&id=7635dba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635dba0",
  null
  
)

export default component.exports